/****   app.js   ****/
// 导入封装好的axios实例
import request from './index'
import qs from 'qs';
// 不同环境的切换
let base = '';
if (process.env.NODE_ENV == 'development') {// 开发
  base = 'http://localhost:8081';
}
else if (process.env.NODE_ENV == 'staging') {
  base = 'http://www.test.unitednev.cn';
}
else if (process.env.NODE_ENV == 'production') {// 线上环境
  base = 'http://web.prod.unitednev.cn';
}
let contentType1 = 'application/x-www-form-urlencoded';
let contentType2 = 'application/json';
   /**
   	*分装适合不同请求类型的方法
     * @param method 请求类型
     * @param url 请求地址
     * @param params 请求参数
     * @param header 请求头
     */
function Request(method, url, params, header) {
  url = `${base}` + url;
  header = { 'Content-Type': header || 'application/json' };
  let config = {};
  switch (method) {
      case 'get':
        config = {
          method: method,
          url: url,
          headers: header
        }
        if(params) config.params = params
        return request(config)
      case 'delete':
        config = {
          method: method,
          url: url,
          headers: header
        }
        if(params) config.params = params
        return request(config)
      case 'post':
        config = {
          method: method,
          url: url,
          headers: header
        }
        if(params) config.data = JSON.stringify(params)
        return request(config)
      case 'put':
        config = {
          method: method,
          url: url,
          headers: header
        }
        if(params) config.data = qs.stringify(params)
        return request(config)
  }
}
export default {
    // 调用封装好的方法，把不同的请求暴露出去
    // loginIn(data) { return Request('post', '/platform/smart/car/getList', data, contentType1) },
    // loginOut(data) { return Request('post', '/platform/smart/cost/list', data, contentType1) },
 }



// WEBPACK FOOTER //
// ./src/api/api.js